{
	"titleFirstPart": "Καλώς ήρθατε στο",
	"titleSecondPart": "Heidelberg Materials {{productName}}",
	"totalCarbonStored": "Συνολικός αποθηκευμένος άνθρακας"
}
